export const HTML_TEXT_PER_PAGE_MAX = 5;
